import { render, staticRenderFns } from "./stu_qulity_njgc.vue?vue&type=template&id=6b358e34&scoped=true"
import script from "./stu_qulity_njgc.vue?vue&type=script&lang=js"
export * from "./stu_qulity_njgc.vue?vue&type=script&lang=js"
import style0 from "./stu_qulity_njgc.vue?vue&type=style&index=0&id=6b358e34&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b358e34",
  null
  
)

export default component.exports